module.exports = __webpack_public_path__ + "images/profile_contact_icon_forward_to_friends.f3c8bc7f.png";